import React from 'react';
import styled from 'styled-components';
import breakpoints from 'theme/breakpoints';
import { TrendingUp } from 'lucide-react';

export default function KpiCard({ label, value, trend, gradient }) {
    return (
        <Card gradient={gradient}>
            <Label>{label}</Label>
            <Value>{value}</Value>
            <TrendRow>
                <TrendingUp size={14} color="#fff" />
                <Trend>{trend}</Trend>
            </TrendRow>
        </Card>
    );
}

const Card = styled.div`
    flex: 1;
    min-width: 200px;
    padding: 20px 24px;
    border-radius: 12px;
    background: ${({ gradient }) => gradient};
    color: #fff;
    margin-right: 16px;
    margin-bottom: 12px;

    &:last-child {
        margin-right: 0;
    }

    @media screen and (max-width: ${breakpoints.md}) {
        margin-right: 0;
    }
`;

const Label = styled.div`
    font-size: 13px;
    font-weight: 500;
    opacity: 0.9;
    margin-bottom: 8px;
`;

const Value = styled.div`
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 6px;
    line-height: 1.1;
`;

const TrendRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

const Trend = styled.span`
    font-size: 12px;
    opacity: 0.85;
`;
